module.exports = __webpack_public_path__ + "static/media/ProfileActive.bc0973f0.svg";